import React, { useState, useEffect, useRef } from 'react'
import useAudioManager from '../hooks/useAudioManager'

const CountdownTimer = ({ initialTime, onComplete }) => {
  const [timeLeft, setTimeLeft] = useState(initialTime)
  const [isBlinking, setIsBlinking] = useState(false)
  const [isExploding, setIsExploding] = useState(false)
  const hasCompleted = useRef(false)
  const hasPlayedSound = useRef(false)
  
  // Инициализация Audio Manager через глобальный audioService
  const { playSound } = useAudioManager({
    timer: 'timer'
  })

  // Звуки теперь управляются через useAudioManager (Web Audio API)
  // Предзагрузка происходит автоматически в хуке

  useEffect(() => {
    // Если таймер уже завершен, не запускаем новые интервалы
    if (hasCompleted.current) {
      return
    }
    
    // Воспроизводим звук таймера один раз в самом начале
    if (timeLeft === initialTime && !hasPlayedSound.current) {
      hasPlayedSound.current = true
      // Задержка для гарантии загрузки аудио
      setTimeout(() => {
        playSound('timer')
      }, 200)
    }
    
    if (timeLeft <= 0) {
      hasCompleted.current = true
      setIsExploding(true)
      
      // Звук взрыва теперь включен в v4_timer_3-2-1-0.mp3, не воспроизводим отдельно
      
      // Вызываем onComplete сразу для начала API запроса
      onComplete()
      return
    }

    const timer = setTimeout(() => {
      setTimeLeft(timeLeft - 1)
      
      // Звук теперь не воспроизводится каждую секунду - он воспроизводится один раз при старте
      
      // Мигание на последних 2 секундах
      if (timeLeft <= 2) {
        setIsBlinking(true)
      }
    }, 1000)

    return () => clearTimeout(timer)
  }, [timeLeft, onComplete, playSound, initialTime])

  return (
    <div className="flex flex-col items-center justify-center mb-8">
      <div className="text-6xl font-orbitron font-bold text-accent-primary mb-2 relative">
        {isExploding ? (
          // Разделяем текст на части для scatter эффекта
          <div className="absolute inset-0 flex justify-center items-center z-index: 50">
            <span 
              className="inline-block"
              style={{ animation: 'scatterLeft 600ms ease-out forwards' }}
            >
              0
            </span>
            <span 
              className="inline-block"
              style={{ animation: 'scatterUp 600ms ease-out forwards', animationDelay: '5ms' }}
            >
              0
            </span>
            <span 
              className="inline-block"
              style={{ animation: 'scatterDown 600ms ease-out forwards', animationDelay: '7ms' }}
            >
              :
            </span>
            <span 
              className="inline-block"
              style={{ animation: 'scatterRight 600ms ease-out forwards', animationDelay: '10ms' }}
            >
              0
            </span>
            <span 
              className="inline-block"
              style={{ animation: 'scatterLeft 600ms ease-out forwards', animationDelay: '15ms' }}
            >
              0
            </span>
          </div>
        ) : (
          <span 
            style={{
              animation: isBlinking ? 'fastBlink 100ms infinite' : 'none'
            }}
          >
            00:{timeLeft.toString().padStart(2, '0')}
          </span>
        )}
      </div>
    </div>
  )
}

export default CountdownTimer
